import { render, staticRenderFns } from "./accessPermissions.vue?vue&type=template&id=0abfd0b6&scoped=true&"
import script from "./accessPermissions.vue?vue&type=script&lang=js&"
export * from "./accessPermissions.vue?vue&type=script&lang=js&"
import style0 from "./accessPermissions.vue?vue&type=style&index=0&id=0abfd0b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abfd0b6",
  null
  
)

export default component.exports